import { gql } from "@apollo/client";

export const LIST_USERS_QUERY = gql`
  query listUsersPaginated($limit: Int, $offset: Int, $ordering: String, $filters: UserFilterType) {
    listUsersPaginated(filter: $filters) {
      totalCount
      results(limit: $limit, offset: $offset, ordering: $ordering) {
        id
        firstName
        lastName
        email
        isActive
        role {
          id
          name
          order
        }
        groups {
          name
          userType
          order
        }
      }
    }
  }
`;

export const CREATE_UPDATE_USER_QUERY = gql`
  mutation CreateUpdateUser($input: CreateUpdateUserInput!) {
    createUpdateUser(input: $input) {
      user {
        id
        firstName
        username
        lastName
        shortName
        email
        accountingFirms
        companies
        isActive
        groups {
          id
          name
          userType
        }
        userCategory {
          id
          name
          slug
        }
        addons {
          id
        }
        startedWorkingAt
        startedWorkingAt
        registrationNumber
        country
      }
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_USER_COMPANIES_PERMISSIONS = gql`
  mutation AddRemoveUserCompaniesInputType(
    $userId: ID
    $addAccountingFirms: [ID]
    $addCompanies: [ID]
    $removeAccountingFirms: [ID]
    $removeCompanies: [ID]
  ) {
    updateUserCompanies(
      input: {
        userId: $userId
        addAccountingFirms: $addAccountingFirms
        addCompanies: $addCompanies
        removeAccountingFirms: $removeAccountingFirms
        removeCompanies: $removeCompanies
      }
    ) {
      accountingFirms
      companies
      errors {
        field
        messages
      }
    }
  }
`;

export const LIST_USER_CLIENTS = gql`
  query listUsersPaginated($search: String, $offset: Int, $company: [ID!]) {
    listUsersPaginated(
      searchContains: $search
      excludeSelf: true
      userCategory_Slug: "client"
      exclude_Companies_Overlap: $company
    ) {
      results(limit: 20, offset: $offset, orderBy: ["email"]) {
        id
        firstName
        lastName
        email
      }
      totalCount
    }
  }
`;

export const LIST_GROUPS = gql`
  query listGroups($filter: GroupFilterInputType) {
    listGroups(filter: $filter) {
      id
      name
      userType
      slug
      order
      permissions
    }
  }
`;

export const GET_USER_ACCESS_QUERY = gql`
  query ($id: ID, $accountingFirmId: ID) {
    getUserAccesses(filter: { id: $id, accountingFirmId: $accountingFirmId }) {
      accountingFirms {
        internalReference
        companiesList
        id
        name
      }
    }
  }
`;
export const GET_USER_ACCESS_COMPANIES_QUERY = gql`
  query ($id: ID, $accountingFirmId: ID) {
    getUserAccesses(filter: { id: $id, accountingFirmId: $accountingFirmId }) {
      accountingFirms {
        companiesList
        id
        name
      }
    }
  }
`;

export const GET_USER_DATA_QUERY = gql`
  query getUser($id: Int) {
    getUser(id: $id) {
      id
      firstName
      username
      lastName
      shortName
      email
      isActive
      isNewraiUser
      phone
      startedWorkingAt
      endedWorkingAt
      registrationNumber
      countryData {
        code
        name
      }
      permissions
      groups {
        id
        name
        userType
        slug
        order
      }
      userCategory {
        id
        name
        slug
      }
      workShift {
        label
        value
      }
      workTime
      receiveNotificationsByEmail
      subscribedNewsletter
      canUseBlockedSsiAccounts
      role {
        id
        name
        order
      }
    }
  }
`;

export const GET_CLIENT_USER_DATA_QUERY = gql`
  query getUser($id: Int) {
    getUser(id: $id) {
      id
      firstName
      lastName
      shortName
      phone
      email
      isActive
      receiveNotificationsByEmail
      subscribedNewsletter
      groups {
        id
      }
      role {
        id
      }
      userCategory {
        id
      }
      addons {
        slug
        companies
      }
    }
  }
`;

export const CREATE_UPDATE_MULTIPLE_USER_ADDONS = gql`
  mutation ($userId: ID!, $companyId: ID!, $addonsList: [String]!) {
    createUpdateMultipleUserAddons(
      input: { userId: $userId, companyId: $companyId, addonsList: $addonsList }
    ) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const LIST_WORKSHIFT_CHOICES = gql`
  query listWorkShiftChoices {
    listWorkShiftChoices {
      label
      value
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword($input: ResetPasswordMutationInput!) {
    resetPassword(input: $input) {
      success
    }
  }
`;

export const GET_GROUPS_IDS = gql`
  query listGroups($filter: GroupFilterInputType) {
    listGroups(filter: $filter) {
      id
    }
  }
`;

export const LIST_USER_CATEGORY = gql`
  query listUserCategory($filter: UserCategoryFilterType) {
    listUserCategory(filter: $filter) {
      id
      slug
      name
    }
  }
`;

export const LIST_ROLES = gql`
  query listRoles($filter: RoleFilterInputType) {
    listRoles(filter: $filter) {
      id
      name
      slug
    }
  }
`;

export const LIST_ROLES_WITH_PERMISSIONS = gql`
  query listRolesWithPermissions($filter: RoleFilterInputType) {
    listRoles(filter: $filter) {
      id
      name
      slug
      groups {
        permissions
      }
    }
  }
`;
